import { createSlice, configureStore } from "@reduxjs/toolkit";

const initialSettings = {
  languageCode: "ro",
  userId: null,
};

const initialData = {
  categoryData: [],
  cartProducts: [],
  activePrinter: null,
};
const settingsSlice = createSlice({
  name: "settings",
  initialState: initialSettings,
  reducers: {
    change(state, action) {
      state.languageCode = action.payload;
    },
    logIn(state, action) {
      state.userId = action.payload;
    },
    logOut(state) {
      state.userId = null;
    },
  },
});

const dataSlice = createSlice({
  name: "data",
  initialState: initialData,
  reducers: {
    addCategories(state, action) {
      state.categoryData = action.payload;
    },
    addActivePrinter(state, action) {
      state.activePrinter = action.payload;
    },

    addProductToCart(state, action) {
      const existingProduct = state.cartProducts.find(
        (product) => product.id === action.payload.id
      );

      if (existingProduct) {
        // If the product is already in cart, increase its quantity
        existingProduct.quantity += action.payload.quantity || 1;
      } else {
        // If not, add it with the given quantity or 1
        state.cartProducts.push({
          ...action.payload,
          quantity: action.payload.quantity || 1,
        });
      }
    },

    removeProductFromCart(state, action) {
      state.cartProducts = state.cartProducts.filter(
        (product) => product.id !== action.payload
      );
    },
    updateProductQuantity(state, action) {
      const productIndex = state.cartProducts.findIndex(
        (product) => product.id === action.payload.id
      );
      if (productIndex !== -1) {
        state.cartProducts[productIndex].quantity = action.payload.quantity;
      }
    },
    clearCart(state) {
      state.cartProducts = [];
    },
    reset(state) {
      state.categoryData = [];
      state.cartProducts = [];
    },
  },
});

const store = configureStore({
  reducer: {
    settings: settingsSlice.reducer,
    data: dataSlice.reducer,
  },
});
export const settingsActions = settingsSlice.actions;
export const dataActions = dataSlice.actions;

export default store;
